import React, { useEffect } from 'react';
import styles from 'feature/common/redirect/index.module.scss';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'query-string';
import localDataService from 'service/local-data-service';

const Redirect = () => {
  const history = useHistory();
  const location = useLocation();
  const urlSearch = qs.parse(location.search).logout;

  useEffect(() => {
    localDataService.clearStorage();
    setTimeout(() => {
      history.replace('/');
    }, 2000);
    // no need to add history for dependency
    // eslint-disable-next-line
  }, []);

  const Text = () => {
    return urlSearch === 'expired' ? (
      <>
        您已登入其他裝置，
        <br />
        或是登入已過期
      </>
    ) : (
      <>您已登出麻吉付</>
    );
  };

  return (
    <div className={styles.redirect}>
      <div className={styles.title}>
        <Text />
      </div>
      <div className={styles['sub-title']}>正在返回首頁...</div>
    </div>
  );
};

export default Redirect;
